import React, { useState, useEffect } from "react";
import Layout from "../../../Components/Layout/layout";
import dashboardclasses from "../../dashboard.module.css";
import { css } from "@emotion/react";
import ScaleLoader from "react-spinners/ScaleLoader";
import { Services } from "../../../Services";
import { toast } from "react-toastify";
import Moment from "react-moment";
import { useNavigate, useParams } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import Styles from "./Styles.module.css";
import DriverModalComp from "./DriverApproval";
import DocumentModal from "./Modal";
import WalletAdjustment from "../WalletAdjustment/Adjustment";
import swal from "sweetalert";

function Products() {
    const headerstyles = {
        color: "#707275",
        fontWeight: 700,
        fontSize: "0.8rem",
    };
    const Navigate = useNavigate();
    const { id } = useParams();

    let [loading, setLoading] = useState(true);
    const [status, setStatus] = useState();
    const [Documents, setDocuments] = useState([]);
    const [documentModal, setDocumentModal] = useState(false);
    const [DocumentAccepted, setDocumentAccepted] = useState(false);
    const [selectedDocument, setselectedDocument] = useState(false);
    const [Drivers, setDrivers] = useState([]);
    const [DriverModal, setDriverModal] = useState(false);
    const [DriverAccepted, setDriverAccepted] = useState(false);
    const [selectedDriver, setselectedDriver] = useState(false);
    const [orders, setOrders] = useState([]);
    const [Adjustment, setAdjustment] = useState(false);
    const [WalletTransactions, setWalletTransactions] = useState([]);
    const [BankDetails, serBankDetails] = useState({
        upi: "",
        ifsc: "",
        branch: "",
        bank_name: "",
        account_no: "",
        account_holder_name: "",
    });
    const token = { Authorization: `token ${sessionStorage.getItem("token")}` };

    const override = css`
        display: block;
        margin: 0 auto;
        border-color: red;
    `;
    const getorders = () => {
        Services.DriverDetails("GET", null, token, id)
            .then((res) => {
                console.log(res);
                setLoading(false);
                if (res.Status === 1) {
                    setOrders(res.Driver);
                    setDocuments(res?.Documents);
                    setDrivers(res?.Vehicles);
                    serBankDetails(res?.BankDetails);
                    setWalletTransactions(res?.WalletTransactions);
                    // setOrdersSearch(res.Orders);
                } else if (res.Status === 0) {
                    toast.error(`${res.Message}`, {
                        position: "top-center",
                        autoClose: 1000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    if (res.Message === "Token expired") {
                        Navigate("/");
                    }
                }
            })
            .catch((err) => {
                // alert(err);
                alert("something went wrong please try again");
                console.log(err);
            });
    };

    useEffect(() => {
        getorders();
        // eslint-disable-next-line
    }, []);
    useEffect(() => {
        if (status) {
            statusHandler();
        }
    }, [status]);

    const orderstatusformatter = (cell) => {
        //eslint-disable-next-line
        if (cell == "1") {
            return (
                <div
                    style={{
                        display: "grid",
                        alignItems: "center",
                        justifyItems: "center",
                        justifySelf: "right",
                        gap: "0.5rem",
                    }}>
                    <div
                        className={`${
                            dashboardclasses[`order-delivered-wrapper`]
                        } ${dashboardclasses[`order-status-wrapper`]}`}>
                        <p className={dashboardclasses["order-delivered"]}>
                            Approved
                        </p>
                    </div>
                </div>
            );
        }
        if (cell == "0") {
            return (
                <div
                    style={{
                        display: "grid",
                        alignItems: "center",
                        justifyItems: "center",
                        justifySelf: "right",
                        gap: "0.5rem",
                    }}>
                    <div
                        className={`${
                            dashboardclasses[`order-delivered-wrapper`]
                        } ${dashboardclasses[`order-status-wrapper`]}`}>
                        <p className={dashboardclasses["order-delivered"]}>
                            Pending Verification
                        </p>
                    </div>
                </div>
            );
        }
    };

    const statusHandler = (e) => {
        setLoading(true);
        let body = {
            status: status,
            type: "service",
        };
        Services.updateOrderStatus("POST", JSON.stringify(body), token, id)
            .then((res) => {
                if (res.Status === 1) {
                    getorders();
                    toast.success(`${res.Message}`, {
                        position: "top-center",
                        autoClose: 1000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    // setOrdersSearch(res.Orders);
                } else if (res.Status === 0) {
                    setLoading(false);
                    toast.error(`${res.Message}`, {
                        position: "top-center",
                        autoClose: 1000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    if (res.Message === "Token expired") {
                        Navigate("/");
                    }
                }
            })
            .catch((err) => {
                // alert(err);
                alert("something went wrong please try again");
                console.log(err);
            });
    };
    let columns = [
        {
            dataField: "driver_document",
            text: "Document Type",
            sort: false,

            headerStyle: (colum, colIndex) => {
                return {
                    ...headerstyles,
                };
            },
        },
        {
            dataField: "document_number",
            text: "Document Number(front)",
            sort: false,

            headerStyle: (colum, colIndex) => {
                return {
                    ...headerstyles,
                };
            },
        },
        {
            dataField: "created_at_formatted",
            text: "upload Date",
            sort: false,
            formatter: (cell) => (cell != "NA" ? cell : "NA"),
            headerStyle: (colum, colIndex) => {
                return {
                    ...headerstyles,
                };
            },
        },
        {
            dataField: "imageURL",
            text: "Document Image",
            sort: false,
            formatter: (cell) =>
                cell != "NA" ? (
                    <a target="_blank" href={cell}>
                        Click Here
                    </a>
                ) : (
                    "NA"
                ),
            headerStyle: (colum, colIndex) => {
                return {
                    ...headerstyles,
                };
            },
        },
        {
            dataField: "imageBackURL",
            text: "Document Image(back)",
            sort: false,
            formatter: (cell) =>
                cell != "NA" ? (
                    <a target="_blank" href={cell}>
                        Click Here
                    </a>
                ) : (
                    "NA"
                ),
            headerStyle: (colum, colIndex) => {
                return {
                    ...headerstyles,
                };
            },
        },
        {
            dataField: "reject_reason",
            text: "Reject Reason",
            sort: false,
            formatter: (cell, cellContent) =>
                cellContent?.is_document_verified == 3 ? cell : "NA",
            headerStyle: (colum, colIndex) => {
                return {
                    ...headerstyles,
                };
            },
        },
        {
            dataField: "is_document_verified",
            text: "Status",
            sort: false,
            formatter: (cell, cellContent) =>
                cell == 2 ? (
                    <div className={Styles["Status_wrapper"]}>
                        <button
                            className={Styles["completed"]}
                            onClick={() => {
                                setselectedDocument(cellContent);
                                setDocumentAccepted(true);
                                setDocumentModal(true);
                                console.log("333");
                            }}>
                            Approve
                        </button>
                        <button
                            className={Styles["pending"]}
                            onClick={() => {
                                setselectedDocument(cellContent);
                                setDocumentAccepted(false);
                                setDocumentModal(true);
                            }}>
                            Reject
                        </button>
                    </div>
                ) : (
                    <p
                        className={
                            cell == 1 ? Styles["completed"] : Styles["pending"]
                        }>
                        {" "}
                        {cell == 1 ? "Approved" : "Rejected"}
                    </p>
                ),
            headerStyle: (colum, colIndex) => {
                return {
                    ...headerstyles,
                };
            },
        },
    ];
    let column2 = [
        {
            dataField: "transport_name",
            text: "Transport",
            sort: false,

            headerStyle: (colum, colIndex) => {
                return {
                    ...headerstyles,
                };
            },
        },
        {
            dataField: "license_number",
            text: "License Number",
            sort: false,

            headerStyle: (colum, colIndex) => {
                return {
                    ...headerstyles,
                };
            },
        },
        {
            dataField: "rc_number",
            text: "RC Number",
            sort: false,

            headerStyle: (colum, colIndex) => {
                return {
                    ...headerstyles,
                };
            },
        },
        {
            dataField: "vehicle_brand",
            text: "Vehcile Brand",
            sort: false,

            headerStyle: (colum, colIndex) => {
                return {
                    ...headerstyles,
                };
            },
        },
        {
            dataField: "vehicle_number",
            text: "Vehcile Number",
            sort: false,

            headerStyle: (colum, colIndex) => {
                return {
                    ...headerstyles,
                };
            },
        },
        {
            dataField: "reject_reason",
            text: "Reject Reason",
            sort: false,
            formatter: (cell, cellContent) =>
                cellContent?.is_vehicle_verified == 3 ? cell : "NA",
            headerStyle: (colum, colIndex) => {
                return {
                    ...headerstyles,
                };
            },
        },
        {
            dataField: "is_vehicle_verified",
            text: "Status",
            sort: false,
            formatter: (cell, cellContent) =>
                cell == 2 ? (
                    <div className={Styles["Status_wrapper"]}>
                        <button
                            className={Styles["completed"]}
                            onClick={() => {
                                setselectedDriver(cellContent);
                                setDriverAccepted(true);
                                setDriverModal(true);
                            }}>
                            Approve
                        </button>
                        <button
                            className={Styles["pending"]}
                            onClick={() => {
                                setselectedDriver(cellContent);
                                setDriverAccepted(false);
                                setDriverModal(true);
                            }}>
                            Reject
                        </button>
                    </div>
                ) : (
                    <p
                        className={
                            cell == 1 ? Styles["completed"] : Styles["pending"]
                        }>
                        {" "}
                        {cell == 1 ? "Approved" : "Rejected"}
                    </p>
                ),
            headerStyle: (colum, colIndex) => {
                return {
                    ...headerstyles,
                };
            },
        },
    ];
    let column3 = [
        {
            dataField: "razorpay_order_id",
            text: "RazorPay ID",
            sort: false,

            headerStyle: (colum, colIndex) => {
                return {
                    ...headerstyles,
                };
            },
        },
        {
            dataField: "amount",
            text: "Amount",
            sort: false,

            headerStyle: (colum, colIndex) => {
                return {
                    ...headerstyles,
                };
            },
        },
        {
            dataField: "createdAtFormatted",
            text: "Transaction Date",
            sort: false,

            headerStyle: (colum, colIndex) => {
                return {
                    ...headerstyles,
                };
            },
        },

        {
            dataField: "notes",
            text: "Notes",
            sort: false,

            headerStyle: (colum, colIndex) => {
                return {
                    ...headerstyles,
                };
            },
        },
        {
            dataField: "transaction_type",
            text: "Status",
            sort: false,
            formatter: (cell, cellContent) => (
                <p
                    className={
                        cell == 1 ? Styles["completed"] : Styles["pending"]
                    }>
                    {" "}
                    {cell == 1 ? "Credit" : "Debit"}
                </p>
            ),
            headerStyle: (colum, colIndex) => {
                return {
                    ...headerstyles,
                };
            },
        },
    ];
    const emptyDataMessage = () => {
        return "No Data to Display";
    };
    const defaultSorted = [
        {
            dataField: "name",
            order: "desc",
        },
    ];
    const clcikHanlder = (row, type) => {
        swal(
            `Are You sure you want to ${type == 0 ? "unblock" : "block"} user?`,
            {
                icon: "warning",
                className: dashboardclasses["logout-popup"],
                dangerMode: true,
                buttons: {
                    cancel: "Cancel",
                    catch: {
                        text: type == 0 ? "unblock" : "block",
                        value: "Delete",
                        className: dashboardclasses[".cancel-delete"],
                    },
                    defeat: false,
                },
            }
        ).then((value) => {
            switch (value) {
                case "Delete":
                    setLoading(true);
                    Services.MobilityDriverUserUpdate(
                        "PATCH",
                        JSON.stringify({ blocked: type }),
                        token,
                        row.id
                    )
                        .then((res) => {
                            if (res.Status === 1) {
                                getorders();
                                toast.success(`${res.Message}`, {
                                    position: "top-center",
                                    autoClose: 1000,
                                    hideProgressBar: true,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                });
                            } else if (res.Status === 0) {
                                setLoading(false);
                                toast.error(`${res.Message}`, {
                                    position: "top-center",
                                    autoClose: 1000,
                                    hideProgressBar: true,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                });
                                if (res.Message === "Token expired") {
                                    Navigate("/");
                                }
                            }
                        })
                        .catch((err) => {
                            // alert(err);
                            setLoading(false);
                            alert("something went wrong please try again");
                            console.log(err);
                        });
                    break;

                // default:
                //     swal("Got away safely!");
            }
        });
    };
    return (
        <>
            <Layout Active={"mobility_drivers"}>
                {Adjustment && (
                    <WalletAdjustment
                        isOpen={Adjustment}
                        setisOpen={setAdjustment}
                        id={id}
                        refetch={() => getorders()}
                    />
                )}
                {documentModal && (
                    <DocumentModal
                        setmodal={setDocumentModal}
                        selectedDocument={selectedDocument}
                        isAccepted={DocumentAccepted}
                        data={id}
                        getOrders={getorders}
                    />
                )}
                {DriverModal && (
                    <DriverModalComp
                        setmodal={setDriverModal}
                        selectedDocument={selectedDriver}
                        isAccepted={DriverAccepted}
                        data={id}
                        getOrders={getorders}
                    />
                )}
                <div className={dashboardclasses["dashboard-rightside"]}>
                    <div className={dashboardclasses.CategoryWrapper}>
                        {loading ? (
                            <div className={dashboardclasses["loader"]}>
                                <ScaleLoader
                                    color={"black"}
                                    loading={true}
                                    css={override}
                                    size={150}
                                />
                            </div>
                        ) : (
                            <>
                                <button
                                    className={dashboardclasses["backbutton"]}
                                    onClick={() => {
                                        Navigate(-1);
                                    }}>
                                    Back
                                </button>
                                <header
                                    className={
                                        dashboardclasses["order-details-header"]
                                    }>
                                    <h3
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "0.5rem",
                                        }}>
                                        Driver Details{" "}
                                        {orderstatusformatter(
                                            orders?.is_driver_verified
                                        )}
                                    </h3>
                                </header>
                                <div
                                    className={
                                        dashboardclasses[
                                            "orders-form-invoice-wrapper"
                                        ]
                                    }>
                                    <div
                                        className={
                                            dashboardclasses[
                                                "orders-form-invoice"
                                            ]
                                        }>
                                        {/*   <div
                                            className={
                                                dashboardclasses[
                                                    "invoice-detail"
                                                ]
                                            }>
                                            <div
                                                className={
                                                    dashboardclasses[
                                                        "detail-status"
                                                    ]
                                                }>
                                                <span>Status:</span>
                                                {orders?.status !=
                                                    "AdminCanceled" &&
                                                orders?.status !=
                                                    "UserCanceled" &&
                                                orders?.status != "Delivered" &&
                                                orders.status !=
                                                    "Payment-Failed" ? (
                                                    <select
                                                        defaultValue={
                                                            orders.orderStatus
                                                        }
                                                        onChange={
                                                            statuschangehandler
                                                        }>
                                                        {" "}
                                                        <option
                                                            value=""
                                                            default>
                                                            Update status
                                                        </option>
                                                    
                                                        <option value="Delivered">
                                                            Delivered{" "}
                                                        </option>
                                                        <option value="AdminCanceled">
                                                            Admin Cancel{" "}
                                                        </option>
                                                    </select>
                                                ) : (
                                                    orderstatusformatter(
                                                        orders.status
                                                    )
                                                )}
                                            </div>
                                            {orders?.status ==
                                                "Payment-Success" && (
                                                <div
                                                    className={
                                                        dashboardclasses[
                                                            "order-handler"
                                                        ]
                                                    }>
                                                    <span>Update Vendor:</span>
                                                    <select
                                                        name=""
                                                        id=""
                                                        style={{
                                                            height: "2rem",
                                                            border: "1px solid #ccc",
                                                        }}
                                                        defaultValue={""}
                                                        onChange={
                                                            changeHandler
                                                        }>
                                                        <option
                                                            value=""
                                                            disabled>
                                                            Update Vendor
                                                        </option>
                                                        {allVendorData?.map(
                                                            (item) => (
                                                                <option
                                                                    value={
                                                                        item.mobile
                                                                    }>
                                                                    {item.name}
                                                                </option>
                                                            )
                                                        )}
                                                    </select>
                                                </div>
                                            )}
                                        </div> */}

                                        <div
                                            className={
                                                dashboardclasses["order-items"]
                                            }>
                                            <header
                                                className={
                                                    dashboardclasses[
                                                        "customer-info-header"
                                                    ]
                                                }>
                                                <h4>
                                                    Driver Info{" "}
                                                    <button
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            clcikHanlder(
                                                                orders,
                                                                orders.blocked ==
                                                                    0
                                                                    ? 1
                                                                    : 0
                                                            );
                                                        }}
                                                        style={{
                                                            fontSize: "1rem",
                                                        }}
                                                        className={
                                                            orders.blocked == 0
                                                                ? dashboardclasses[
                                                                      "red"
                                                                  ]
                                                                : dashboardclasses[
                                                                      "green"
                                                                  ]
                                                        }>
                                                        {orders.blocked == 0
                                                            ? "Block"
                                                            : "Unblock"}{" "}
                                                    </button>
                                                    <button
                                                        style={{
                                                            fontSize: "1rem",
                                                            marginLeft: "1rem",
                                                        }}
                                                        onClick={() =>
                                                            setAdjustment(true)
                                                        }
                                                        className={
                                                            dashboardclasses[
                                                                "red"
                                                            ]
                                                        }>
                                                        Wallet Adjustment
                                                    </button>
                                                </h4>
                                            </header>

                                            <div
                                                style={{
                                                    display: "flex",
                                                    gap: "1rem",
                                                    flexWrap: "wrap",
                                                    alignContent: "center",
                                                    // width: "100%",
                                                    justifyContent:
                                                        "space-between",
                                                }}>
                                                <div
                                                    className={
                                                        dashboardclasses[
                                                            "order-item-data"
                                                        ]
                                                    }
                                                    style={{ flexGrow: "1" }}>
                                                    <div
                                                        className={
                                                            dashboardclasses[
                                                                "order-date"
                                                            ]
                                                        }>
                                                        <h5>Name</h5>
                                                        <h4>:</h4>
                                                        <p>{orders.name} </p>
                                                    </div>

                                                    <div
                                                        className={
                                                            dashboardclasses[
                                                                "order-date"
                                                            ]
                                                        }>
                                                        <h5>Contact Number</h5>
                                                        <h4>:</h4>
                                                        <p>{orders.mobile}</p>
                                                    </div>
                                                    <div
                                                        className={
                                                            dashboardclasses[
                                                                "order-date"
                                                            ]
                                                        }>
                                                        <h5>Email</h5>
                                                        <h4>:</h4>
                                                        <p> {orders.emailid}</p>
                                                    </div>
                                                    <div
                                                        className={
                                                            dashboardclasses[
                                                                "order-date"
                                                            ]
                                                        }>
                                                        <h5>Wallet Amount</h5>
                                                        <h4>:</h4>
                                                        <p>
                                                            {" "}
                                                            Rs.{" "}
                                                            {
                                                                orders.walletAmount
                                                            }
                                                        </p>
                                                    </div>
                                                    <div
                                                        className={
                                                            dashboardclasses[
                                                                "order-date"
                                                            ]
                                                        }>
                                                        <h5>
                                                            rideWallet Balance
                                                        </h5>
                                                        <h4>:</h4>
                                                        <p>
                                                            {" "}
                                                            Rs.{" "}
                                                            {
                                                                orders.rideWalletBalance
                                                            }
                                                        </p>
                                                    </div>
                                                    <div
                                                        className={
                                                            dashboardclasses[
                                                                "order-date"
                                                            ]
                                                        }>
                                                        <h5>DOB</h5>
                                                        <h4>:</h4>
                                                        <p> {orders.dob}</p>
                                                    </div>
                                                    <div
                                                        className={
                                                            dashboardclasses[
                                                                "order-date"
                                                            ]
                                                        }>
                                                        <h5>Gender</h5>
                                                        <h4>:</h4>
                                                        <p> {orders.gender}</p>
                                                    </div>
                                                    <div
                                                        className={
                                                            dashboardclasses[
                                                                "order-date"
                                                            ]
                                                        }>
                                                        <h5>Address</h5>
                                                        <h4>:</h4>
                                                        <p>
                                                            {" "}
                                                            {
                                                                orders.address
                                                            }, <br />{" "}
                                                            {orders?.city},
                                                            <br />{" "}
                                                            {orders?.pincode}
                                                        </p>
                                                    </div>
                                                    <div
                                                        className={
                                                            dashboardclasses[
                                                                "order-date"
                                                            ]
                                                        }>
                                                        <h5>Role</h5>
                                                        <h4>:</h4>
                                                        <p>
                                                            {" "}
                                                            {
                                                                orders?.serviceTypeName
                                                            }
                                                        </p>
                                                    </div>
                                                </div>
                                                <div
                                                    className={
                                                        dashboardclasses[
                                                            "order-item-data"
                                                        ]
                                                    }
                                                    style={{ flexGrow: "1" }}>
                                                    <div
                                                        className={
                                                            dashboardclasses[
                                                                "order-date"
                                                            ]
                                                        }>
                                                        <h5>
                                                            Account Holder Name
                                                        </h5>
                                                        <h4>:</h4>
                                                        <p>
                                                            {
                                                                BankDetails.account_holder_name
                                                            }{" "}
                                                        </p>
                                                    </div>

                                                    <div
                                                        className={
                                                            dashboardclasses[
                                                                "order-date"
                                                            ]
                                                        }>
                                                        <h5>Account No</h5>
                                                        <h4>:</h4>
                                                        <p>
                                                            {
                                                                BankDetails.account_no
                                                            }
                                                        </p>
                                                    </div>
                                                    <div
                                                        className={
                                                            dashboardclasses[
                                                                "order-date"
                                                            ]
                                                        }>
                                                        <h5>Bank Name</h5>
                                                        <h4>:</h4>
                                                        <p>
                                                            {" "}
                                                            {
                                                                BankDetails.bank_name
                                                            }
                                                        </p>
                                                    </div>
                                                    <div
                                                        className={
                                                            dashboardclasses[
                                                                "order-date"
                                                            ]
                                                        }>
                                                        <h5>Branch</h5>
                                                        <h4>:</h4>
                                                        <p>
                                                            {" "}
                                                            {BankDetails.branch}
                                                        </p>
                                                    </div>
                                                    <div
                                                        className={
                                                            dashboardclasses[
                                                                "order-date"
                                                            ]
                                                        }>
                                                        <h5>IFSC</h5>
                                                        <h4>:</h4>
                                                        <p>
                                                            {" "}
                                                            {BankDetails.ifsc}
                                                        </p>
                                                    </div>
                                                    <div
                                                        className={
                                                            dashboardclasses[
                                                                "order-date"
                                                            ]
                                                        }>
                                                        <h5>UPI</h5>
                                                        <h4>:</h4>
                                                        <p>
                                                            {" "}
                                                            {BankDetails.upi}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <h3 style={{ marginTop: "1rem" }}>
                                            {" "}
                                            Documents
                                        </h3>
                                        <div className="category-table">
                                            <BootstrapTable
                                                bootstrap4
                                                keyField="id"
                                                data={Documents}
                                                columns={columns}
                                                defaultSorted={defaultSorted}
                                                // pagination={pagination}
                                                wrapperClasses="table-responsive"
                                                noDataIndication={
                                                    emptyDataMessage
                                                }
                                            />
                                        </div>
                                        <h3 style={{ marginTop: "1rem" }}>
                                            {" "}
                                            Vehicles
                                        </h3>
                                        <div className="category-table">
                                            <BootstrapTable
                                                bootstrap4
                                                keyField="id"
                                                data={Drivers}
                                                columns={column2}
                                                defaultSorted={defaultSorted}
                                                // pagination={pagination}
                                                wrapperClasses="table-responsive"
                                                noDataIndication={
                                                    emptyDataMessage
                                                }
                                            />
                                        </div>
                                        <h3 style={{ marginTop: "1rem" }}>
                                            {" "}
                                            Wallet Transactions
                                        </h3>
                                        <div className="category-table">
                                            <BootstrapTable
                                                bootstrap4
                                                keyField="id"
                                                data={WalletTransactions}
                                                columns={column3}
                                                defaultSorted={defaultSorted}
                                                // pagination={pagination}
                                                wrapperClasses="table-responsive"
                                                noDataIndication={
                                                    emptyDataMessage
                                                }
                                            />
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </Layout>
        </>
    );
}

export default Products;
